export default "__VITE_ASSET__BzeqyEtb__"